import React from "react";
import { PaziaBox } from "components/atoms";
import { TrainerHoursSummary } from "./TrainerHoursSummary";
import { TrainerCostEntriesTable } from "./TrainerCostEntriesTable";

interface TrainerCostsSectionProps {
  courseId: number;
  className?: string;
}
// "Godziny trenerów" + "Koszty trenerów", shown on the schedule tab and in the course finances overview.
export const TrainerCostsSection = ({ courseId, className = "" }: TrainerCostsSectionProps) => (
  <PaziaBox className={className}>
    <TrainerHoursSummary courseId={courseId} />
    <hr className="my-4 border-slate-200 dark:border-slate-700" />
    <TrainerCostEntriesTable courseId={courseId} />
  </PaziaBox>
);
